import { observer } from "mobx-react-lite";
import React from "react";

import { Stack, TextBadge, TextBadgeColor } from "@bps/fluent-ui";

import { LocationStatusToggleButton } from "./LocationStatusToggleButton.tsx";
import { OrgUnitScreenData } from "./utils.ts";

interface LocationStatusButtonsProps extends OrgUnitScreenData {
  onReactivate: () => void;
}

export const LocationStatusButtons: React.FC<LocationStatusButtonsProps> =
  observer(props => {
    const statusColor = props.orgUnit.isInactive
      ? TextBadgeColor.grey
      : TextBadgeColor.green;

    const getStatusText = () => {
      if (props.pracOrgUnit.isDefault) {
        return "Default location";
      }
      if (props.orgUnit.isInactive) {
        return "Inactive location";
      }
      return "Active location";
    };

    return (
      <Stack horizontal tokens={{ childrenGap: 8 }}>
        <TextBadge badgeColor={statusColor} hasBorder={false}>
          {getStatusText()}
        </TextBadge>
        <LocationStatusToggleButton {...props} />
      </Stack>
    );
  });
